import React  from 'react';

import BrokerGross from './broker_gross';
import CustomColumns from './custom_columns';
import SaveButton from './save_button';

export default function PipelineViewSettings() {
  return (
    <div className="view-settings">
      <h2>Pipeline View</h2>
      <BrokerGross />
      <CustomColumns />
      <div>
        <SaveButton />
      </div>
    </div>
  );
}
